import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {PackageConfigurationEntity} from "../../models/package-configuration.model";
import {SettingsService} from "../../services/settings-service.service";

export class PackageConfigurationSelectComponent implements IController {

  form: any;
  selectedId: any;
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  onChange: Function;


  public selectedConfiguration: PackageConfigurationEntity;
  public selectedText: any;
  public defaultPackageConfig: PackageConfigurationEntity;

  constructor(private $mdPanel, private settingsService: SettingsService, private splitService: SplitService) {
  }

  $onInit() {
    this.defaultPackageConfig = this.splitService.getSiteDefaultPackageConfiguration();
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'package-configuration';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }


        if (!selectedId) {
          this.onChange({agent: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const agent = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({agent: agent, id: selectedId});
            panel.destroy();
          } else {
            this.settingsService.getOnePackageConfiguration(selectedId)
              .then((packageConfiguration: PackageConfigurationEntity) => {
                this.selectedConfiguration = packageConfiguration
                this._setSelectedText()

                this.onChange({packageConfiguration: packageConfiguration, id: selectedId});
                panel.destroy();
              })

          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({agent: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedConfiguration = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.settingsService.getOnePackageConfiguration(this.selectedId)
          .then((packageConfiguration: PackageConfigurationEntity) => {
            this.selectedConfiguration = packageConfiguration
            this._setSelectedText()
          })

      }
    } else {
      this.selectedConfiguration = this.defaultPackageConfig;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText =  _.get(this.selectedConfiguration, 'name', '') ;
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageConfigurationSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./package-configuration-select.html').default,
    controller: PackageConfigurationSelectComponent
  });

